module.exports = __webpack_public_path__ + "static/media/irish-rail.76b3e4d6.jpg";